<ion-card [class.active]="active"
          [class.animate-in]="order.animateEntry"
          [class.waiting-received]="order.status === orderStatuses.RECEIVED && !order.terminalOrder && !active"
          [class.waiting-preparing]="order.status === orderStatuses.PREPARING && !order.terminalOrder && !active"
          [class.waiting-ready]="order.status === orderStatuses.READY && !order.terminalOrder && !active">
    <ion-card-header class="header-container"
                     [color]="(includePaymentStatus && !order.invoiceCreated && (order.tabPaymentStatus === paymentStatuses.UNPAID || order.tabPaymentStatus === paymentStatuses.PARTIAL_PAID || order.tabPaymentStatus === paymentStatuses.OVER_PAID)) ? 'danger' : order.status | orderStatusColor"
                     (click)="header($event)">
        <div *ngIf="includeTableStandMarker"
             class="table-marker"
             [class.table-marker-none]="!order.tableStandMarker && order.tableStandMarker !== 0"
             (click)="editTableMarker()">{{ !!order.tableStandMarker || order.tableStandMarker === 0 ? order.tableStandMarker : 'None' }}
        </div>
        <ion-card-title>
            <div class="card-title">
                <ion-icon *ngIf="!order.terminalOrder" name="phone-portrait-outline" class="mobile-order"></ion-icon>
                <span>{{ !!order.tabPersonName ? order.tabPersonName : 'Terminal Order' }} ({{ order.date | dateAgo:true }})</span>
                <p *ngIf="includeCustomerAreaPosition"
                   class="pointer sub-header"
                   (click)="changeCustomerPosition($event)">{{
                        !!order.customerAreaPosition
                            ? order.customerAreaPosition.formattedValue()
                            : 'Pickup'
                    }}</p>
                <p class="sub-header">{{ order.date | date:'M/d/yy h:mm a' }}</p>
            </div>
        </ion-card-title>
        <div *ngIf="hideTotal || !details || !!order.orderMarker || order.orderMarker === 0 || order.tableStandMarker || order.tableStandMarker; else detailsElseBlock"
             class="header-details ion-text-center"
             (click)="viewDetailsClicked($event)">
            <ng-container *ngIf="order.status === orderStatuses.READY; else elseBlock">
                <div *ngIf="!!order.orderMarker || order.orderMarker === 0" class="order-marker">{{ order.orderMarker }}</div>
                <div *ngIf="!order.orderMarker && order.orderMarker !== 0 && !!order.customerAreaPosition" class="order-marker">
                    {{ order.customerAreaPosition.formattedValue() }}
                </div>
            </ng-container>
            <ng-template #elseBlock>
                <span *ngIf="hideTotal || !details && (!includePaymentStatus || order.invoiceCreated || order.tabPaymentStatus === paymentStatuses.PAID || order.tabPaymentStatus === paymentStatuses.PRE_AUTH)"
                      class="details-message">Details</span>
                <span *ngIf="includePaymentStatus && !order.invoiceCreated && (order.tabPaymentStatus === paymentStatuses.UNPAID || order.tabPaymentStatus === paymentStatuses.PARTIAL_PAID || order.tabPaymentStatus === paymentStatuses.OVER_PAID)"
                      class="details-message">Payment Issue</span>
            </ng-template>

            <ion-buttons *ngIf="canPrint" class="print-button">
                <ion-button (click)="print($event)">
                    <ion-icon name="print-outline" slot="icon-only"></ion-icon>
                </ion-button>
            </ion-buttons>
        </div>
        <ng-template #detailsElseBlock>
            <div class="header-details ion-text-center">
                <ion-buttons *ngIf="canPrint" class="print-button">
                    <ion-button (click)="print($event)">
                        <ion-icon name="print-outline" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </div>
        </ng-template>
    </ion-card-header>
    <ion-card-content>
        <ion-grid *ngIf="!!order.status" (click)="editTableMarker()">
            <ion-row>
                <ion-col class="order-notes">
                    {{ order.notes }}
                </ion-col>
            </ion-row>
        </ion-grid>
        <bb-display-order [order]="order"
                          [compact]="!details"
                          [details]="details"
                          [hideTotal]="hideTotal"
                          [editable]="editable"
                          [selectedItemIds]="selectedItemIds"
                          [availableOrderComps]="availableOrderComps"
                          (addCredit)="addCredit.emit($event)"
                          (removeCredit)="removeCredit.emit($event)"
                          (removeTokens)="removeTokens.emit($event)"
                          (addTokens)="addTokens.emit($event)"
                          (itemsSelected)="toggleSelect($event)"
                          (layout)="layout.emit()">
        </bb-display-order>

        <ion-grid #statusGrid>
            <ion-row>
                <ion-col size-xs="12">
                    <ion-segment [(ngModel)]="currentStatus"
                                 mode="ios"
                                 [scrollable]="true"
                                 (ionChange)="confirmStatusChange($event.detail.value)">
                        <ion-segment-button [disabled]="currentStatus === orderStatuses.CANCELED" value="RECEIVED" class="status-received">
                            <ion-label>
                                <h2 *ngIf="fullText">Received</h2>
                                <h2 *ngIf="!fullText">Rec</h2>
                            </ion-label>
                        </ion-segment-button>
                        <ion-segment-button [disabled]="currentStatus === orderStatuses.CANCELED" value="PREPARING" class="status-preparing">
                            <ion-label>
                                <h2 *ngIf="fullText">Preparing</h2>
                                <h2 *ngIf="!fullText">Prp</h2>
                            </ion-label>
                        </ion-segment-button>
                        <ion-segment-button [disabled]="currentStatus === orderStatuses.CANCELED" value="READY" class="status-ready">
                            <ion-label>
                                <h2 *ngIf="fullText">Ready</h2>
                                <h2 *ngIf="!fullText">Rdy</h2>
                            </ion-label>
                        </ion-segment-button>
                        <ion-segment-button [disabled]="currentStatus === orderStatuses.CANCELED" value="DELIVERED" class="status-delivered">
                            <ion-label>
                                <h2 *ngIf="fullText">Delivered</h2>
                                <h2 *ngIf="!fullText">Dlv</h2>
                            </ion-label>
                        </ion-segment-button>
                        <ion-segment-button [disabled]="currentStatus === orderStatuses.CANCELED || !authorizedToCancel()" value="CANCELED"
                                            class="status-canceled">
                            <ion-label>
                                <h2 *ngIf="fullText">Canceled</h2>
                                <h2 *ngIf="!fullText">Cncl</h2>
                            </ion-label>
                        </ion-segment-button>
                    </ion-segment>
                </ion-col>
            </ion-row>
            <ion-row *ngIf="includeServerOptions">
                <ion-col *ngIf="!!order.server">
                    <ion-button class="full-footer-button" (click)="assignServer()" color="dark">
                        {{ order.server.name }}
                    </ion-button>
                </ion-col>
                <ion-col *ngIf="!order.server">
                    <ion-button class="paired-button" (click)="claimServer()" color="dark">
                        Claim
                    </ion-button>
                    <ion-button class="paired-button" (click)="assignServer()" color="dark">
                        Assign
                    </ion-button>
                </ion-col>
            </ion-row>
            <ion-row *ngIf="includeOrderAgain || (includeMoveOption && currentUser.authorizedTo(featureKeys.ORDER_MOVE, order.orgId))">
                <ion-col *ngIf="includeOrderAgain">
                    <ion-button class="full-footer-button"
                                color="dark"
                                (click)="orderAgain.emit(order)">
                        Order Again
                    </ion-button>
                </ion-col>
                <ion-col>
                    <ion-button class="full-footer-button"
                                color="dark"
                                (click)="move()">
                        Move
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card-content>
</ion-card>

<ion-modal [isOpen]="showPrintSelection"
           css-class="select-button-modal"
           (didDismiss)="showPrintSelection = false">
    <ng-template>
        <modal-header title="Print"></modal-header>
        <ion-content>
            <ion-grid>
                <ion-row>
                    <ion-col size-xs="6">
                        <ion-button class="selection-option"
                                    color="dark"
                                    (click)="delegatePrint()">
                            <div class="option-container">
                                Delegate To Assigned Printers
                            </div>
                        </ion-button>
                    </ion-col>
                    <ion-col size-xs="6">
                        <ion-button class="selection-option"
                                    color="dark"
                                    (click)="individualPrint()">
                            <div class="option-container">
                                Print
                            </div>
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ng-template>
</ion-modal>
